import * as React from 'react';

import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';

import Dashboard from './dashboard/dashboard';
import Home from './home/home';
import { Switch, Redirect } from 'react-router';

const Routes = ({ match }) => (
  <>
    <Switch>
      <ErrorBoundaryRoute path={`${match.url}dashboard`} component={Dashboard} />
      <ErrorBoundaryRoute path={`${match.url}home/:id/:index`} component={Home} />
    </Switch>
  </>
);

export default Routes;
